import { CarQueue } from './car-queue';
import { fetchWithTimeout } from './fetchWithTimeout';

export type Store = {
    storeId?: string;
    storeName?: string;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    carQueues?: CarQueue[];
    select?: (keyof Store)[];
    order?: { [P in keyof Store]: 'ASC' | 'DESC' | 'asc' | 'desc' | 1 | -1 };
    loadEagerRelations?: boolean;
};

type CreateRequestData = Store & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Store;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('store/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Store[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('store/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = Store & {
    select?: (keyof Store)[];
    loadEagerRelations?: boolean;
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Store[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('store/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = Store & { storeId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Store;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('store/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Store[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('store/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = Store & { storeId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('store/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('store/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk };
